// // code sahi hai but out of stcok wal work nhi kar raha tha client add karne ko bola hai new api banya hai uske liye niche code add karke usme chnges akr rahe baki ye code sahi hai

// import React, { useEffect, useState } from "react";
// import Layout from "../../Layout/Layout";
// import axios from "axios";
// import { Link, useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import { AddToCart } from "./AddtoCart";
// import { useWishlist } from "../../../Context/WishlistContext";
// import { useCart } from "../../../Context/CartContext";
// import FooterNew from "../../Layout/FooterNew";
// import SEO from "../../SEO";
// const DISCOUNT_API = "https://ecom.cyberathon.com/index.php/Api/get_products_by_discount";
// const BASE_URL = "https://ecom.cyberathon.com/index.php/Api";
// function ProductsAPI2() {
//   const [categories, setCategories] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [addedItems, setAddedItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const { wishlistItems, toggleWishlist } = useWishlist();
//   const [offerProduct,setOfferProduct] = useState([]);
//   const [seoData, setSeoData] = useState({});
//   const location = useLocation();
//   const navigate = useNavigate();

//   // ── Offer state from HomeOffers navigation ──
//   const offerState = location.state || {};
//   const offerDiscount = offerState.offerDiscount;        // e.g. "20"
//   const offerProdIds  = offerState.offerProdIds || [];   // e.g. ["403","404"]
//   const offerLabel    = offerState.offerLabel || `${offerDiscount}% Off Products`;

//   useEffect(() => {
//     fetchData();
//     loadCartItems();
//   }, []);

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const [cat, prod] = await Promise.all([
//         axios.get("https://ecom.cyberathon.com/index.php/Api/list_category"),
//         axios.get("https://ecom.cyberathon.com/index.php/Api/list_get_product"),
//       ]);

//       setCategories(cat.data.data);

//       const groupedProducts = {};
//       const onlyProducts = prod.data.products.filter(
//         (item) => item.product_type === "product"
//       );

//       onlyProducts.forEach((item) => {
//         if (!groupedProducts[item.prod_id]) {
//           groupedProducts[item.prod_id] = { ...item, variants: [] };
//         }
//         if (item.size_id) {
//           groupedProducts[item.prod_id].variants.push({
//             size_id: item.size_id,
//             current_price: item.current_price,
//             old_price: item.old_price,
//           });
//         }
//       });

//       setProducts(Object.values(groupedProducts));
//     } catch (err) {
//       console.error("Error fetching data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadCartItems = async () => {
//     const userId = sessionStorage.getItem("userId");
//     const cartToken = localStorage.getItem("cart_token");
//     if (!userId && !cartToken) return;
//     try {
//       const res = await axios.post(
//         "https://ecom.cyberathon.com/index.php/Api/list_cart",
//         { user_id: userId || null, cart_token: userId ? null : cartToken }
//       );
//       if (res.data.status) {
//         setAddedItems(res.data.cart_items.map((item) => item.prod_id));
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   // Scroll to category if navigated with categoryKey
//   useEffect(() => {
//     if (!loading && location.state?.categoryKey) {
//       let section = document.getElementById(location.state.categoryKey);
//       if (!section) {
//         section = document.querySelector(`[data-id="${location.state.categoryKey}"]`);
//       }
//       if (section) {
//         section.scrollIntoView({ behavior: "smooth", block: "start" });
//       }
//     }
//   }, [loading, location.state]);

//   // Scroll to offer section when navigated from HomeOffers
//   useEffect(() => {
//     if (!loading && offerDiscount) {
//       const el = document.getElementById("offer-section-top");
//       if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
//     }
//   }, [loading, offerDiscount]);

//   const getProductsByCategory = (id) =>
//     products.filter((p) => p.category_id === id);

//   const usedCategoryIds = categories.map((c) => c.category_id);
//   const moreItems = products.filter((p) => !usedCategoryIds.includes(p.category_id));

//   // ── Offer products: prod_ids from card section ──
//   // Products whose prod_id is in offerProdIds
//  useEffect(()=>{
//   if(offerDiscount){
//     fetchOfferProduct();
//   }
//  },[offerDiscount]);
//  const fetchOfferProduct = async () =>{
//   try{
//     const res = await axios.post(DISCOUNT_API,{
//       discount:offerDiscount,
//     })
//     // if(res.data.status){
//     //   setOfferProduct(res.data.data);
//     // }
//     if (res.data.status) {
//   const formatted = res.data.data.map((item) => ({
//     ...item,
//     variants: [],          // required for UI
//     category_id: "offer",  // dummy (important)
//     discription: "",       // fallback
//   }));

//   setOfferProduct(formatted);
// }
//   }catch(error){
//     console.error("Discount products error:", error);
//   }
//  }
// useEffect(() => {
//   const fetchSeo = async () => {
//     try {
//       const response = await axios.post(`${BASE_URL}/get_seo_by_page`, { page_name: 'product' });

//       if (response.data.status === 'true') {
//         const data = response.data.data;
//         setSeoData({
//           title: data.meta_title,
//           description: data.meta_description,
//           keywords: data.meta_keywords,
//           canonical: data.canonical_url,
//         });
//       }
//     } catch (error) {
//       console.error('SEO fetch error:', error);
//     }
//   };

//   fetchSeo();
// }, []);
//   return (
//     <>
//      <SEO
//   title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
//   description={seoData.description || "Get in touch with ShopIndia for support, queries, or feedback."}
//   keywords={seoData.keywords || "ShopIndia, contact, support, feedback"}
//   canonical={seoData.canonical || "https://www.shopindia.com/contact"}
// />
//       <Layout />

//       {loading ? (
//         <div className="container-fluid px-lg-5 px-2 py-5" style={{ minHeight: "70vh" }}>
//           <div className="text-center py-5">
//             <div className="spinner-border text-primary" role="status"
//               style={{ width: "3rem", height: "3rem" }}>
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <p className="mt-3 fw-bold">Loading products...</p>
//           </div>
//         </div>
//       ) : (
//         <>
//           {/* ══ OFFER SECTION — shown at top when coming from HomeOffers ══ */}
//           {offerProduct.length > 0 && (
//             <div id="offer-section-top">
//               {/* Banner strip */}
//               <div
//                 className="container-fluid px-lg-5 px-2 py-2"
//                 style={{
//                   background: "linear-gradient(90deg, #ff6b35 0%, #f7931e 100%)",
//                 }}
//               >
//                 <div className="d-flex align-items-center gap-3">
//                   <span className="fs-4">🔥</span>
//                   <div>
//                     <h5 className="mb-0 fw-bold text-white">{offerLabel}</h5>
//                     <small className="text-white opacity-75">
//                       {offerProduct.length} product{offerProduct.length > 1 ? "s" : ""} with this offer
//                     </small>
//                   </div>
//                   <span
//                     className="ms-auto badge text-white border border-white"
//                     style={{ fontSize: "1rem", background: "rgba(255,255,255,0.2)" }}
//                   >
//                     {offerDiscount}% OFF
//                   </span>
//                 </div>
//               </div>

//               {/* Offer products grid */}
//               <CategorySection
//                 title=""
//                 products={offerProduct}
//                 addedItems={addedItems}
//                 setAddedItems={setAddedItems}
//                 bgClass="bg-warning-subtle"
//               />

//               {/* Divider */}
//               <div className="container-fluid px-lg-5 px-2 py-2">
//                 <hr className="border-2" />
//                 <p className="text-muted text-center mb-0">All Products</p>
//               </div>
//             </div>
//           )}

//           {/* ══ ALL CATEGORIES ══ */}
//           {categories.map((cat) => {
//             const catProducts = getProductsByCategory(cat.category_id);
//             return (
//               <div
//                 id={cat.category_name.replaceAll(" ", "")}
//                 key={cat.category_id}
//                 data-id={cat.category_id}
//               >
//                 <CategorySection
//                   title={cat.category_name}
//                   products={catProducts}
//                   addedItems={addedItems}
//                   setAddedItems={setAddedItems}
//                 />
//               </div>
//             );
//           })}

//           {moreItems.length > 0 && (
//             <div id="MoreItems">
//               <CategorySection
//                 title="More Items"
//                 products={moreItems}
//                 addedItems={addedItems}
//                 setAddedItems={setAddedItems}
//               />
//             </div>
//           )}
//         </>
//       )}

//       <FooterNew />
//     </>
//   );
// }

// export default ProductsAPI2;

// // ═══════════════════════════════════════════════
// // CategorySection — unchanged logic, added bgClass prop
// // ═══════════════════════════════════════════════
// function CategorySection({ title, products, addedItems, setAddedItems, bgClass = "backcolor1" }) {
//   const [shareProduct, setShareProduct] = useState(null);
//   const [shareUrl, setShareUrl] = useState("");
//   const { setCartCount } = useCart();
//   const { wishlistItems, toggleWishlist } = useWishlist();

//   const formatCardDescription = (html) => {
//     if (!html) return "";
//     return html
//       .replace(/<[^>]*>/g, " ")
//       .replace(/\d+\./g, "")
//       .replace(/\s+/g, " ")
//       .trim();
//   };

//   const handleAddToCart = async (prod_id) => {
//     try {
//       const res = await AddToCart(prod_id, 1);
//       if (res.data.status === true) {
//         setAddedItems((prev) => [...prev, prod_id]);
//         setCartCount((prev) => prev + 1);
//       } else {
//         alert(res.data.message);
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Error while adding to cart");
//     }
//   };

//   const renderStars = (rating) => {
//     const stars = [];
//     const fullStars = Math.floor(rating);
//     const hasHalfStar = rating % 1 !== 0;
//     const emptyStars = 5 - Math.ceil(rating);
//     for (let i = 0; i < fullStars; i++)
//       stars.push(<i key={"f" + i} className="fa-solid fa-star text-warning"></i>);
//     if (hasHalfStar)
//       stars.push(<i key="half" className="fa-solid fa-star-half-stroke text-warning"></i>);
//     for (let i = 0; i < emptyStars; i++)
//       stars.push(<i key={"e" + i} className="fa-regular fa-star text-warning"></i>);
//     return stars;
//   };

//   const handleShare = (product) => {
//     const baseUrl =
//       window.location.hostname === "localhost"
//         ? "http://localhost:3000"
//         : "https://shopeindia.co.in";
//     setShareProduct(product);
//     setShareUrl(`${baseUrl}/DetailsSection3/${product.prod_id}`);
//   };

//   return (
//     <>
//       <div className={`container-fluid px-lg-5 px-2 py-3 ${bgClass}`}>
//         {title && <h3 className="mb-3 pt-1">{title}</h3>}

//         <div className="row gapp">
//           {products.length > 0 ? (
//             products.map((p, index) => {
//               const displayPrice =
//                 p.variant_price && p.variant_price !== "0.00"
//                   ? p.variant_price
//                   : p.current_price;
//               const displayOldPrice =
//                 p.variant_old_price && p.variant_old_price !== "0.00"
//                   ? p.variant_old_price
//                   : p.old_price;

//               // 14-july-2026 product 3pecie, 5 pecie add kanr eko bola
//               // ★ Quantity set ke liye label banao (listing me dikhega)
//               const qtySetLabel = (() => {
//                 if (p.price_type !== "quantity_set") return "";
//                 let qv = p.quantity_variants;
//                 if (!qv) return "";
//                 // ★ FIX: string ho to parse karo
//                 if (typeof qv === "string") {
//                   try { qv = JSON.parse(qv); } catch { return ""; }
//                 }
//                 if (!Array.isArray(qv) || qv.length === 0) return "";
//                 const labels = qv.map(v => v.label || `${v.quantity} Pc`);
//                 return labels.join(" / ");
//               })();

//               return (
//                 <div className="col-6 col-sm-6 col-md-3 col-lg-3 mb-3"
//                   key={p.prod_id + "-" + index}>
//                   <div className="card custom-card">
//                     <div className="position-relative">
//                       <Link to={`/DetailsSection3/${p.prod_id}`}>
//                         <img
//                           src={`https://ecom.cyberathon.com/${p.Product_image?.[0]}`}
//                           className="card-img-top mt-1"
//                           alt={p.Product_name}
//                         />
//                       </Link>
//                       <i
//                         className={`position-absolute top-0 end-0 m-2 fs-5 px-2 py-1 shadow rounded-circle ${
//                           wishlistItems.includes(p.prod_id)
//                             ? "bi bi-suit-heart-fill text-danger bg-white"
//                             : "bi bi-suit-heart text-white bg-dark bg-opacity-50"
//                         }`}
//                         style={{ cursor: "pointer", zIndex: 2 }}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           toggleWishlist(p.prod_id);
//                         }}
//                       ></i>
//                       <i
//                         className="bi bi-share position-absolute top-0 start-0 m-2 fs-5 px-2 py-1 bg-white rounded-circle"
//                         style={{ cursor: "pointer", zIndex: 2 }}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleShare(p);
//                         }}
//                       ></i>
//                       <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">
//                         {p.discount}% off
//                       </span>
//                     </div>

//                     <div className="card-body text-start">
//                       <Link to={`/DetailsSection3/${p.prod_id}`}
//                         className="text-decoration-none text-dark">
//                         <h6 className="fw-bold two-line-ellipsis product-title">
//                           {p.Product_name}
//                         </h6>
//                         <small className="d-block desc-space one-line-ellipsis">
//                           {p.discription?.trim()
//                             ? formatCardDescription(p.discription)
//                             : "\u00A0"}
//                         </small>

//                         <div className="price-space">
//                           {displayPrice ? (
//                             <>
//                               <p className="text-success fw-bold mb-0">₹{displayPrice}</p>
//                               {displayOldPrice && (
//                                 <small className="text-muted text-decoration-line-through">
//                                   ₹{displayOldPrice}
//                                 </small>
//                               )}
//                               {/* {qtySetLabel && (
//                                 <small className="text-primary d-block mt-1">{qtySetLabel}</small>
//                               )} */}
//                             </>
//                           ) : (
//                             "\u00A0"
//                           )}
//                         </div>

//                         <div className="rating-space">
//                           {p.rating ? (
//                             <>
//                               {renderStars(p.rating)}
//                               <small className="text-dark ms-1">({p.rating})</small>
//                             </>
//                           ) : (
//                             "\u00A0"
//                           )}
//                         </div>
//                       </Link>

//                       <div
//                         className="bg-col text-white fw-semibold py-2 rounded text-center"
//                         style={{
//                           cursor: addedItems.includes(p.prod_id) ? "default" : "pointer",
//                         }}
//                         onClick={() =>
//                           !addedItems.includes(p.prod_id) && handleAddToCart(p.prod_id)
//                         }
//                       >
//                         {addedItems.includes(p.prod_id) ? (
//                           <>Added <span className="ms-2"><i className="bi bi-check2"></i></span></>
//                         ) : (
//                           <>Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span></>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })
//           ) : (
//             <p>No products found in this category.</p>
//           )}
//         </div>
//       </div>

//       {/* Share popup */}
//       {shareProduct && (
//         <div className="share-overlay">
//           <div className="share-popup">
//             <div className="d-flex justify-content-between mb-3">
//               <h5>Share Product</h5>
//               <i className="bi bi-x-lg" style={{ cursor: "pointer" }}
//                 onClick={() => setShareProduct(null)}></i>
//             </div>
//             <input type="text" value={shareUrl} readOnly className="form-control mb-3" />
//             <div className="d-flex justify-content-around">
//               <a
//                 href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
//                   shareProduct.Product_name + " " + shareUrl
//                 )}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <i className="bi bi-whatsapp text-success fs-3"></i>
//               </a>
//               <button
//                 onClick={() => {
//                   navigator.clipboard.writeText(shareUrl);
//                   alert("Link copied!");
//                 }}
//               >
//                 <i className="bi bi-link-45deg fs-3"></i>
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }










// 27-july2026  out of stcok notify add akrne ke bad wala code upar ka code bhi sahi tha bas usme out of stock wala dikh nhi raha tha isme new api add karke kiya hai
import React, { useEffect, useState } from "react";
import Layout from "../../Layout/Layout";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { AddToCart } from "./AddtoCart";
import { useWishlist } from "../../../Context/WishlistContext";
import { useCart } from "../../../Context/CartContext";
import FooterNew from "../../Layout/FooterNew";
import SEO from "../../SEO";
const DISCOUNT_API =
  "https://ecom.cyberathon.com/index.php/Api/get_products_by_discount";
const BASE_URL = "https://ecom.cyberathon.com/index.php/Api";

const isProductOutOfStock = (product) => {
  if (!product.stock_status) return false;
  const status = String(product.stock_status).toLowerCase().trim();
  return (
    status === "out of stock" ||
    status === "out_of_stock" ||
    status === "outofstock" ||
    status === "0"
  );
};

// const hasValidDiscount = (product) => {
//   const discount = Number(product.discount);
//   return !isNaN(discount) && discount > 0;
// };

const hasValidDiscount = (product) => {
  const offDiscount = Number(product.off_discount);   // ★ CHANGED: discount → off_discount
  return !isNaN(offDiscount) && offDiscount > 0;
};

function ProductsAPI2() {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [addedItems, setAddedItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { wishlistItems, toggleWishlist } = useWishlist();
  const [offerProduct, setOfferProduct] = useState([]);
  const [seoData, setSeoData] = useState({});
  const location = useLocation();
  const navigate = useNavigate();

  // ── Offer state from HomeOffers navigation ──
  const offerState = location.state || {};
  const offerDiscount = offerState.offerDiscount; // e.g. "20"
  const offerProdIds = offerState.offerProdIds || []; // e.g. ["403","404"]
  const offerLabel = offerState.offerLabel || `${offerDiscount}% Off Products`;

  useEffect(() => {
    fetchData();
    loadCartItems();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [cat, prod] = await Promise.all([
        axios.get("https://ecom.cyberathon.com/index.php/Api/list_category"),
        axios.get("https://ecom.cyberathon.com/index.php/Api/list_get_product"),
      ]);

      setCategories(cat.data.data);

      const groupedProducts = {};
      const onlyProducts = prod.data.products.filter(
        (item) => item.product_type === "product",
      );

      onlyProducts.forEach((item) => {
        if (!groupedProducts[item.prod_id]) {
          groupedProducts[item.prod_id] = { ...item, variants: [] };
        }
        if (item.size_id) {
          groupedProducts[item.prod_id].variants.push({
            size_id: item.size_id,
            current_price: item.current_price,
            old_price: item.old_price,
          });
        }
      });

      setProducts(Object.values(groupedProducts));
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  const loadCartItems = async () => {
    const userId = sessionStorage.getItem("userId");
    const cartToken = localStorage.getItem("cart_token");
    if (!userId && !cartToken) return;
    try {
      const res = await axios.post(
        "https://ecom.cyberathon.com/index.php/Api/list_cart",
        { user_id: userId || null, cart_token: userId ? null : cartToken },
      );
      if (res.data.status) {
        setAddedItems(res.data.cart_items.map((item) => item.prod_id));
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Scroll to category if navigated with categoryKey
  useEffect(() => {
    if (!loading && location.state?.categoryKey) {
      let section = document.getElementById(location.state.categoryKey);
      if (!section) {
        section = document.querySelector(
          `[data-id="${location.state.categoryKey}"]`,
        );
      }
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [loading, location.state]);

  // Scroll to offer section when navigated from HomeOffers
  useEffect(() => {
    if (!loading && offerDiscount) {
      const el = document.getElementById("offer-section-top");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [loading, offerDiscount]);

  const getProductsByCategory = (id) =>
    products.filter((p) => p.category_id === id);

  const usedCategoryIds = categories.map((c) => c.category_id);
  const moreItems = products.filter(
    (p) => !usedCategoryIds.includes(p.category_id),
  );

  // ── Offer products: prod_ids from card section ──
  // Products whose prod_id is in offerProdIds
  useEffect(() => {
    if (offerDiscount) {
      fetchOfferProduct();
    }
  }, [offerDiscount]);
  const fetchOfferProduct = async () => {
    try {
      const res = await axios.post(DISCOUNT_API, {
        discount: offerDiscount,
      });
      // if(res.data.status){
      //   setOfferProduct(res.data.data);
      // }
      if (res.data.status) {
        const formatted = res.data.data.map((item) => ({
          ...item,
          variants: [], // required for UI
          category_id: "offer", // dummy (important)
          discription: "", // fallback
        }));

        setOfferProduct(formatted);
      }
    } catch (error) {
      console.error("Discount products error:", error);
    }
  };
  useEffect(() => {
    const fetchSeo = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/get_seo_by_page`, {
          page_name: "product",
        });

        if (response.data.status === "true") {
          const data = response.data.data;
          setSeoData({
            title: data.meta_title,
            description: data.meta_description,
            keywords: data.meta_keywords,
            canonical: data.canonical_url,
          });
        }
      } catch (error) {
        console.error("SEO fetch error:", error);
      }
    };

    fetchSeo();
  }, []);
  return (
    <>
      <SEO
        title={
          seoData.title ||
          "best cupping therapy tools ,authentic cupping supplies | shopeindia"
        }
        description={
          seoData.description ||
          "Get in touch with ShopIndia for support, queries, or feedback."
        }
        keywords={seoData.keywords || "ShopIndia, contact, support, feedback"}
        canonical={seoData.canonical || "https://www.shopindia.com/contact"}
      />
      <Layout />

      {loading ? (
        <div
          className="container-fluid px-lg-5 px-2 py-5"
          style={{ minHeight: "70vh" }}
        >
          <div className="text-center py-5">
            <div
              className="spinner-border text-primary"
              role="status"
              style={{ width: "3rem", height: "3rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 fw-bold">Loading products...</p>
          </div>
        </div>
      ) : (
        <>
          {/* ══ OFFER SECTION — shown at top when coming from HomeOffers ══ */}
          {offerProduct.length > 0 && (
            <div id="offer-section-top">
              {/* Banner strip */}
              <div
                className="container-fluid px-lg-5 px-2 py-2"
                style={{
                  background:
                    "linear-gradient(90deg, #ff6b35 0%, #f7931e 100%)",
                }}
              >
                <div className="d-flex align-items-center gap-3">
                  <span className="fs-4">🔥</span>
                  <div>
                    <h5 className="mb-0 fw-bold text-white">{offerLabel}</h5>
                    <small className="text-white opacity-75">
                      {offerProduct.length} product
                      {offerProduct.length > 1 ? "s" : ""} with this offer
                    </small>
                  </div>
                  <span
                    className="ms-auto badge text-white border border-white"
                    style={{
                      fontSize: "1rem",
                      background: "rgba(255,255,255,0.2)",
                    }}
                  >
                    {offerDiscount}% OFF
                  </span>
                </div>
              </div>

              {/* Offer products grid */}
              <CategorySection
                title=""
                products={offerProduct}
                addedItems={addedItems}
                setAddedItems={setAddedItems}
                bgClass="bg-warning-subtle"
              />

              {/* Divider */}
              <div className="container-fluid px-lg-5 px-2 py-2">
                <hr className="border-2" />
                <p className="text-muted text-center mb-0">All Products</p>
              </div>
            </div>
          )}

          {/* ══ ALL CATEGORIES ══ */}
          {categories.map((cat) => {
            const catProducts = getProductsByCategory(cat.category_id);
            return (
              <div
                id={cat.category_name.replaceAll(" ", "")}
                key={cat.category_id}
                data-id={cat.category_id}
              >
                <CategorySection
                  title={cat.category_name}
                  products={catProducts}
                  addedItems={addedItems}
                  setAddedItems={setAddedItems}
                />
              </div>
            );
          })}

          {moreItems.length > 0 && (
            <div id="MoreItems">
              <CategorySection
                title="More Items"
                products={moreItems}
                addedItems={addedItems}
                setAddedItems={setAddedItems}
              />
            </div>
          )}
        </>
      )}

      <FooterNew />
    </>
  );
}

export default ProductsAPI2;

// ═══════════════════════════════════════════════
// CategorySection — unchanged logic, added bgClass prop
// ═══════════════════════════════════════════════
function CategorySection({
  title,
  products,
  addedItems,
  setAddedItems,
  bgClass = "backcolor1",
}) {
  const [shareProduct, setShareProduct] = useState(null);
  const [shareUrl, setShareUrl] = useState("");
  const { setCartCount, setShowLogin, setRedirectAfterLogin } = useCart();
  const [notifyRequested, setNotifyRequested] = useState({});
  const [notifyLoading, setNotifyLoading] = useState({});
  const { wishlistItems, toggleWishlist } = useWishlist();

  const formatCardDescription = (html) => {
    if (!html) return "";
    return html
      .replace(/<[^>]*>/g, " ")
      .replace(/\d+\./g, "")
      .replace(/\s+/g, " ")
      .trim();
  };

  const handleAddToCart = async (prod_id) => {
    try {
      const res = await AddToCart(prod_id, 1);
      if (res.data.status === true) {
        setAddedItems((prev) => [...prev, prod_id]);
        setCartCount((prev) => prev + 1);
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Error while adding to cart");
    }
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < fullStars; i++)
      stars.push(
        <i key={"f" + i} className="fa-solid fa-star text-warning"></i>,
      );
    if (hasHalfStar)
      stars.push(
        <i
          key="half"
          className="fa-solid fa-star-half-stroke text-warning"
        ></i>,
      );
    for (let i = 0; i < emptyStars; i++)
      stars.push(
        <i key={"e" + i} className="fa-regular fa-star text-warning"></i>,
      );
    return stars;
  };

  const handleShare = (product) => {
    const baseUrl =
      window.location.hostname === "localhost"
        ? "http://localhost:3000"
        : "https://shopeindia.co.in";
    setShareProduct(product);
    setShareUrl(`${baseUrl}/DetailsSection3/${product.prod_id}`);
  };

  const handleNotifyMe = async (product) => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      setRedirectAfterLogin(window.location.pathname);
      setShowLogin(true);
      return;
    }
    const prodId = product.prod_id;
    setNotifyLoading((prev) => ({ ...prev, [prodId]: true }));
    try {
      const res = await axios.post(
        "https://ecom.cyberathon.com/index.php/Api/add_stock_notification",
        {
          user_id: userId,
          prod_id: prodId,
          message: "Notify me when this product is back in stock",
        },
      );
      if (res.data.status === "true" || res.data.status === true) {
        setNotifyRequested((prev) => ({ ...prev, [prodId]: true }));
        alert("We will notify you when this product is back in stock.");
      } else {
        alert(res.data.message || "Failed to send notification");
      }
    } catch (err) {
      alert("Failed to send notification. Please try again.");
    } finally {
      setNotifyLoading((prev) => ({ ...prev, [prodId]: false }));
    }
  };

  return (
    <>
      <div className={`container-fluid px-lg-5 px-2 py-3 ${bgClass}`}>
        {title && <h3 className="mb-3 pt-1">{title}</h3>}

        <div className="row gapp">
          {products.length > 0 ? (
            products.map((p, index) => {
              const displayPrice =
                p.variant_price && p.variant_price !== "0.00"
                  ? p.variant_price
                  : p.current_price;
              const displayOldPrice =
                p.variant_old_price && p.variant_old_price !== "0.00"
                  ? p.variant_old_price
                  : p.old_price;

              // 14-july-2026 product 3pecie, 5 pecie add kanr eko bola
              // ★ Quantity set ke liye label banao (listing me dikhega)
              const qtySetLabel = (() => {
                if (p.price_type !== "quantity_set") return "";
                let qv = p.quantity_variants;
                if (!qv) return "";
                // ★ FIX: string ho to parse karo
                if (typeof qv === "string") {
                  try {
                    qv = JSON.parse(qv);
                  } catch {
                    return "";
                  }
                }
                if (!Array.isArray(qv) || qv.length === 0) return "";
                const labels = qv.map((v) => v.label || `${v.quantity} Pc`);
                return labels.join(" / ");
              })();

              return (
                <div
                  className="col-6 col-sm-6 col-md-3 col-lg-3 mb-3"
                  key={p.prod_id + "-" + index}
                >
                  <div className="card custom-card">
                    <div className="position-relative">
                      <Link to={`/DetailsSection3/${p.prod_id}`}>
                        <img
                          src={`https://ecom.cyberathon.com/${p.Product_image?.[0]}`}
                          className="card-img-top mt-1"
                          alt={p.Product_name}
                        />
                      </Link>
                      <i
                        className={`position-absolute top-0 end-0 m-2 fs-5 px-2 py-1 shadow rounded-circle ${
                          wishlistItems.includes(p.prod_id)
                            ? "bi bi-suit-heart-fill text-danger bg-white"
                            : "bi bi-suit-heart text-white bg-dark bg-opacity-50"
                        }`}
                        style={{ cursor: "pointer", zIndex: 2 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleWishlist(p.prod_id);
                        }}
                      ></i>
                      <i
                        className="bi bi-share position-absolute top-0 start-0 m-2 fs-5 px-2 py-1 bg-white rounded-circle"
                        style={{ cursor: "pointer", zIndex: 2 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleShare(p);
                        }}
                      ></i>
                      {/* <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">
                        {p.discount}% off
                      </span> */}

                      {/* {isProductOutOfStock(p) ? (
  <span className="badge bg-danger position-absolute bottom-0 start-0 rounded-0" style={{fontSize:"0.75rem"}}>
    Out of Stock
  </span>
) : (
  <span className="badge bg-danger position-absolute bottom-0 start-0 rounded-0">
    {p.discount}% off
  </span>
)} */}

                      {/* {isProductOutOfStock(p) ? (
                        <span
                          className="badge bg-danger position-absolute bottom-0 start-0 rounded-0"
                          style={{ fontSize: "0.75rem" }}
                        >
                          Out of Stock
                        </span>
                      ) : hasValidDiscount(p) ? (
                        <span className="badge bg-danger position-absolute bottom-0 start-0 rounded-0">
                          {p.discount}% off
                        </span>
                      ) : null} */}


                      {isProductOutOfStock(p) ? (
                        <span
                          className="badge bg-danger position-absolute bottom-0 start-0 rounded-0"
                          style={{ fontSize: "0.75rem" }}
                        >
                          Out of Stock
                        </span>
                      ) : hasValidDiscount(p) ? (
                        <span className="badge bg-danger position-absolute bottom-0 start-0 rounded-0">
                          {p.off_discount}% off   {/* ★ CHANGED: discount → off_discount */}
                        </span>
                      ) : null}
                    </div>

                    <div className="card-body text-start">
                      <Link
                        to={`/DetailsSection3/${p.prod_id}`}
                        className="text-decoration-none text-dark"
                      >
                        {/* ★ NEW: pdetails_sheading - off badge ke niche, title ke upar */}
                        {p.pdetails_sheading && (
                          <small className="d-block card-subheading one-line-ellipsis">
                            {p.pdetails_sheading}
                          </small>
                        )}

                        <h6 className="fw-bold two-line-ellipsis product-title">
                          {p.Product_name}
                        </h6>
                        <small className="d-block desc-space one-line-ellipsis">
                          {p.discription?.trim()
                            ? formatCardDescription(p.discription)
                            : "\u00A0"}
                        </small>

                        <div className="price-space">
                          {displayPrice ? (
                            <>
                              <p className="text-dark fw-bold mb-0">
                                ₹{displayPrice}
                              </p>
                              {displayOldPrice && (
                                <small className="text-muted text-decoration-line-through">
                                  ₹{displayOldPrice}
                                </small>
                              )}
                              {/* {qtySetLabel && (
                                <small className="text-primary d-block mt-1">{qtySetLabel}</small>
                              )} */}
                            </>
                          ) : (
                            "\u00A0"
                          )}
                        </div>

                        <div className="rating-space">
                          {p.rating ? (
                            <>
                              {renderStars(p.rating)}
                              <small className="text-dark ms-1">
                                ({p.rating})
                              </small>
                            </>
                          ) : (
                            "\u00A0"
                          )}
                        </div>
                      </Link>

                      {/* <div
                        className="bg-col text-white fw-semibold py-2 rounded text-center"
                        style={{
                          cursor: addedItems.includes(p.prod_id) ? "default" : "pointer",
                        }}
                        onClick={() =>
                          !addedItems.includes(p.prod_id) && handleAddToCart(p.prod_id)
                        }
                      >
                        {addedItems.includes(p.prod_id) ? (
                          <>Added <span className="ms-2"><i className="bi bi-check2"></i></span></>
                        ) : (
                          <>Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span></>
                        )}
                      </div> */}

                      {/* {isProductOutOfStock(p) ? (
                        <div
                          className={`py-2 rounded text-center fw-semibold ${
                            notifyRequested[p.prod_id]
                              ? "bg-secondary text-white"
                              : "notify-me-btn"
                          }`}
                          style={{
                            cursor:
                              notifyRequested[p.prod_id] ||
                              notifyLoading[p.prod_id]
                                ? "default"
                                : "pointer",
                          }}
                          onClick={() => {
                            if (
                              !notifyRequested[p.prod_id] &&
                              !notifyLoading[p.prod_id]
                            )
                              handleNotifyMe(p);
                          }}
                        >
                          {notifyLoading[p.prod_id] ? (
                            <>
                              Sending...{" "}
                              <i className="bi bi-arrow-repeat spin-icon ms-1"></i>
                            </>
                          ) : notifyRequested[p.prod_id] ? (
                            <>
                              Notification Sent{" "}
                              <i className="bi bi-bell-fill ms-1"></i>
                            </>
                          ) : (
                            <>
                              Notify Me <i className="bi bi-bell ms-1"></i>
                            </>
                          )}
                        </div>
                      ) : (
                        <div
                          className="bg-col text-white fw-semibold py-2 rounded text-center"
                          style={{
                            cursor: addedItems.includes(p.prod_id)
                              ? "default"
                              : "pointer",
                          }}
                          onClick={() =>
                            !addedItems.includes(p.prod_id) &&
                            handleAddToCart(p.prod_id)
                          }
                        >
                          {addedItems.includes(p.prod_id) ? (
                            <>
                              Added{" "}
                              <span className="ms-2">
                                <i className="bi bi-check2"></i>
                              </span>
                            </>
                          ) : (
                            <>
                              Add to Cart{" "}
                              <span className="ms-2">
                                <i className="bi bi-bag"></i>
                              </span>
                            </>
                          )}
                        </div>
                      )} */}

                      {isProductOutOfStock(p) ? (
  <div
    className={`py-2 rounded text-center fw-semibold ${
      notifyRequested[p.prod_id] ? "bg-secondary text-white" : "notify-me-btn"
    }`}
    style={{ cursor: notifyRequested[p.prod_id] || notifyLoading[p.prod_id] ? "default" : "pointer" }}
    onClick={() => {
      if (!notifyRequested[p.prod_id] && !notifyLoading[p.prod_id]) handleNotifyMe(p);
    }}
  >
    {notifyLoading[p.prod_id] ? (
      <>Sending... <i className="bi bi-arrow-repeat spin-icon ms-1"></i></>
    ) : notifyRequested[p.prod_id] ? (
      <>Notification Sent <i className="bi bi-bell-fill ms-1"></i></>
    ) : (
      <>Notify Me <i className="bi bi-bell ms-1"></i></>
    )}
  </div>
) : (
  (() => {
    const hasVariants =
      (p.variants && p.variants.length > 0) ||
      p.price_type === "quantity_set";

    const isAdded = hasVariants
      ? false
      : addedItems.includes(String(p.prod_id));

    return (
      <div
        className="bg-col text-white fw-semibold py-2 rounded text-center"
        style={{
          cursor: isAdded ? "default" : "pointer",
        }}
        onClick={() =>
          !isAdded && handleAddToCart(p.prod_id)
        }
      >
        {isAdded ? (
          <>Added <span className="ms-2"><i className="bi bi-check2"></i></span></>
        ) : (
          <>Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span></>
        )}
      </div>
    );
  })()
)}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <p>No products found in this category.</p>
          )}
        </div>
      </div>

      {/* Share popup */}
      {shareProduct && (
        <div className="share-overlay">
          <div className="share-popup">
            <div className="d-flex justify-content-between mb-3">
              <h5>Share Product</h5>
              <i
                className="bi bi-x-lg"
                style={{ cursor: "pointer" }}
                onClick={() => setShareProduct(null)}
              ></i>
            </div>
            <input
              type="text"
              value={shareUrl}
              readOnly
              className="form-control mb-3"
            />
            <div className="d-flex justify-content-around">
              <a
                href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                  shareProduct.Product_name + " " + shareUrl,
                )}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-whatsapp text-success fs-3"></i>
              </a>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(shareUrl);
                  alert("Link copied!");
                }}
              >
                <i className="bi bi-link-45deg fs-3"></i>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
